import { DistributionRequestDTO } from "./DistributionRequestDTO";
import { UserRoleDTO } from "./UserRoleDTO";

export class InsertUpdateDistributionDTO{
  model: DistributionRequestDTO[];
  user: UserRoleDTO;
}